import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'get-component-properties' as const;

const argumentZod = z.object({
  componentId: z
    .string()
    .describe('The id of the component, from list-site-components'),
  limit: z
    .number()
    .int()
    .min(1)
    .max(100)
    .optional()
    .describe('Max properties to return per page (1-100, default 100)'),
  offset: z
    .number()
    .int()
    .min(0)
    .optional()
    .describe('Number of properties to skip for pagination (default 0)'),
});

export const getComponentPropertiesManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get component properties',
  prettyStatus: {
    executing: 'Getting component properties…',
    executed: 'Got component properties',
    failed: 'Getting component properties failed',
  },
  family: 'localization',
  llmTool: {
    name: toolName,
    description:
      "Lists a component's translatable properties (id, label, and kind), paginated. Use a property's id as propId when excluding it from translation with create-translation-exclusions (kind: component-prop). To exclude the whole component instead of a single property, use propId 'canvas' with propKind 'canvas' -- canvas is always available and is not listed here.",
    inputSchema: argumentZod,
  },
  type: 'server',
  requiredScopes: ['sites:read'],
  permission: [{resource: 'Site', action: 'read'}],
  confirmBeforeExecuting: false,
  isReadOnly: () => true,
});

export type GetComponentPropertiesArgumentType = z.infer<typeof argumentZod>;
